<div class="dash-page p-4" id="dashboard-main-flex">

  <!-- Greeting -->
  <div class="dash-hero mb-4">
    <p class="dash-date mb-1">{{todayLabel}}</p>
    <h1 class="dash-greeting mb-0">{{greeting}}<span *ngIf="firstName">, {{firstName}}</span>.</h1>
  </div>

  <!-- Admin stat tiles (school/dashboardstats; shown only to school admins) -->
  <div class="dash-stats mb-4" *ngIf="adminStats">
    <div class="dash-stat dash-stat--primary">
      <span class="dash-stat-label">Collected this month</span>
      <span class="dash-stat-value">{{currencySymbol()}}{{compactAmount(adminStats.collectedThisMonth)}}</span>
      <span class="dash-stat-sub">From {{adminStats.paymentsThisMonth}} payment{{adminStats.paymentsThisMonth === 1 ? '' : 's'}}</span>
    </div>
    <div class="dash-stat">
      <span class="dash-stat-label">Collected last month</span>
      <span class="dash-stat-value">{{currencySymbol()}}{{compactAmount(adminStats.collectedLastMonth)}}</span>
      <span class="dash-stat-sub">Gross, before fees</span>
    </div>
    <div class="dash-stat">
      <span class="dash-stat-label">Students in top course</span>
      <span class="dash-stat-value">{{adminStats.topCourses[0]?.studentCount ?? 0}}</span>
      <span class="dash-stat-sub text-truncate">{{adminStats.topCourses[0]?.moduleName ?? 'No courses yet'}}</span>
    </div>
    <div class="dash-stat">
      <span class="dash-stat-label">Active students</span>
      <span class="dash-stat-value">{{adminStats.activeStudents}}<span class="dash-stat-of"> / {{adminStats.totalStudents}}</span></span>
      <span class="dash-stat-sub">Active / total students</span>
    </div>
    <div class="dash-stat dash-stat--dark">
      <span class="dash-stat-label">To mark</span>
      <span class="dash-stat-value">{{adminStats.submissionsToMark}}</span>
      <span class="dash-stat-sub">Submission{{adminStats.submissionsToMark === 1 ? '' : 's'}} waiting for a score</span>
    </div>
  </div>

  <!-- Stat tiles (existing data only) -->
  <div class="dash-stats mb-4" *ngIf="!adminStats">
    <div class="dash-stat dash-stat--primary">
      <span class="dash-stat-label">My courses</span>
      <span class="dash-stat-value">{{courses?.length ?? 0}}</span>
    </div>
    <div class="dash-stat dash-stat--dark">
      <span class="dash-stat-label">Pending assessments</span>
      <span class="dash-stat-value">{{pendingCount}}</span>
      <a routerLink="/user/studentassessments" class="dash-stat-link">View assessments &rarr;</a>
    </div>
  </div>

  <div class="dash-grid">
    <!-- Main column -->
    <div class="dash-main">

      <section class="dash-card mb-4">
        <div class="dash-card-head">
          <h2 class="dash-card-title">Today</h2>
        </div>
        <p *ngIf="todayEvents.length === 0" class="dash-empty mb-0">Nothing scheduled for today.</p>
        <div *ngFor="let event of todayEvents" class="dash-today-row">
          <span class="dash-today-time">{{eventTime(event)}}</span>
          <span class="dash-pill" [class.dash-pill--due]="eventKind(event) === 'Due'">{{eventKind(event)}}</span>
          <span class="dash-today-title flex-fill">{{event.title}}</span>
          <button type="button" class="dash-btn" (click)="popupEvent(event)">View</button>
        </div>
      </section>

      <section class="dash-card mb-4" *ngIf="adminStats">
        <div class="dash-card-head">
          <h2 class="dash-card-title">New enrolments</h2>
          <div class="dash-toggle">
            <button type="button" [class.active]="enrolmentRange === 'weeks'" (click)="loadAdminStats('weeks')">8 weeks</button>
            <button type="button" [class.active]="enrolmentRange === 'months'" (click)="loadAdminStats('months')">6 months</button>
          </div>
        </div>
        <div class="dash-bars">
          <div *ngFor="let bucket of adminStats.enrolments; let last = last" class="dash-bar-col" [class.dash-bar-col--current]="last">
            <span class="dash-bar-value">{{bucket.count}}</span>
            <div class="dash-bar" [style.height.%]="barPercent(bucket.count, enrolmentMax)"></div>
            <span class="dash-bar-label">{{bucket.label}}</span>
          </div>
        </div>
      </section>

      <section id="dashboardcourses" [hidden]="!showdashboard" class="dash-card mb-4">
        <div class="dash-card-head">
          <h2 class="dash-card-title">My Courses</h2>
        </div>
        <p *ngIf="!this.headerinfo.pageloading && (!courses || courses.length === 0 )" class="dash-empty mb-0">You Are Not Enrolled For Any Courses</p>
        <ul *ngIf="courses && courses.length > 0" class="progress-cards-wrap" id="coursessection">
          <li *ngFor="let course of courses">
            <app-moduleslistitem [module]="course" [fromDash]="true"></app-moduleslistitem>
          </li>
        </ul>
      </section>
    </div>

    <!-- Side column -->
    <div class="dash-side">

      <!-- Calendar: markup and ids unchanged, only wrapped in a card -->
      <section class="dash-card mb-4">
        <div id="calendar-holder" [hidden]="!showCalendar">
          <div id="calendar-holder-inner">
            <div  id="calendar-holder-inner-div">
              <div id="calendar" class="bg-white shadow-sm-darker text-primary-darker text-center text-xs inverted-agenda"></div>
              <hr class="mb-0" />
            </div>
            <div class="d-flex flex-column justify-content-evenly align-items-center pb-2 calendar-details" id="details" *ngIf="filterdEvents.length > 0">
              <div class="rounded-md shadow-sm-darker eventcalendardetails">
                <div id="calenderupcomingeventsection" class="p-3" >
                  <h3 class="text-center text-primary-darker">Upcoming Events <br> {{filterdEvents[0].start.substring(0, 10)}}</h3>
                  <div *ngFor="let event of filterdEvents" class="p-2">
                    <div class="rounded shadow-sm-darker">

                      <div class="text-xs add-item-btn w-100 d-flex justify-content-between py-1 px-0" (click)="popupEvent(event)" >
                        <div style="background-color: var(--primary-darker) !important; color: var(--subColor)" id="sticker">
                        </div>
                        <div class="p-2 flex-fill">
                          <div class="d-block">{{event.title}}</div>
                          <div style="font-size: xx-small;">
                            <span class="d-block">Start: {{util.formatDate(event.startdate)}}</span>
                            <span class="d-block" >End: {{util.formatDate(event.enddate)}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr class="m-0">
                  </div>
                </div>
              </div>
            </div>
            <div [hidden]="!showCalendar" class="pb-2 stickertextcontainer calendar-details" *ngIf="filterdEvents.length == 0">
              <p class="text-sm text-center align-middle">Tap/click on calender cell to view event(s) for that day. <br> Select sticker to see event details</p>
            </div>
          </div>
        </div>
      </section>

      <ng-container *ngIf="adminStats">
        <section class="dash-card mb-4">
          <div class="dash-card-head">
            <h2 class="dash-card-title">Top courses</h2>
          </div>
          <p *ngIf="adminStats.topCourses.length === 0" class="dash-empty mb-0">No courses yet.</p>
          <div *ngFor="let course of adminStats.topCourses; let i = index" class="dash-rank-row">
            <span class="dash-rank-badge" [class.dash-rank-badge--dark]="i === 1">{{course.moduleName?.charAt(0)}}</span>
            <div class="flex-fill min-w-0">
              <div class="dash-rank-name text-truncate">{{course.moduleName}}</div>
              <div class="dash-meter"><div [style.width.%]="barPercent(course.studentCount, adminStats.topCourses[0].studentCount)"></div></div>
            </div>
            <span class="dash-rank-count">{{course.studentCount}}</span>
          </div>
        </section>

        <section class="dash-card mb-4">
          <div class="dash-card-head">
            <h2 class="dash-card-title">Top lessons</h2>
            <span class="dash-muted-sm">Views, last 30 days</span>
          </div>
          <p *ngIf="adminStats.topLessons.length === 0" class="dash-empty mb-0">No lesson views in the last 30 days.</p>
          <div *ngFor="let lesson of adminStats.topLessons" class="dash-rank-row">
            <div class="flex-fill min-w-0">
              <div class="dash-rank-name text-truncate">{{lesson.classTitle}}</div>
              <div class="dash-muted-sm text-truncate">{{lesson.moduleName}}</div>
            </div>
            <span class="dash-rank-count">{{lesson.views}}</span>
          </div>
        </section>
      </ng-container>

      <section id="dashboardassessments" class="dash-card" *ngIf="!adminStats">
        <div class="dash-card-head">
          <h2 class="dash-card-title">My Assessments</h2>
          <a routerLink="/user/studentassessments" class="dash-link">All</a>
        </div>
        <p *ngIf="!this.headerinfo.pageloading && (!assessments || assessments.length === 0 ) && pendingassignment" class="dash-empty mb-0">No Pending Assessments</p>
        <ul *ngIf="assessments && assessments.length > 0" class="list-group list-group-flush">
          <li *ngFor="let assessment of assessments" class="list-group-item px-0 bg-transparent">
            <app-dashboarduserassessmentdetail [assessment]="assessment"></app-dashboarduserassessmentdetail>
          </li>
        </ul>
      </section>
    </div>
  </div>
</div>
<app-event-modal [eventDetail]="eventDetail"></app-event-modal>
